/**
 * Impact & Metrics Translations Module (Japanese)
 * 
 * Contains: YFI Formula, YFI Rankings, Performance KPIs, Advanced Metrics, Engagement Metrics
 * Streamlined version - matches English structure
 * 
 * @module impact
 * @language ja
 */

export const impact = {
  impactMetrics: {
    pageTitle: "インパクトとメトリクス",
    pageSubtitle: "114のJCI国全体で若者のリーダーシップ、メンタルヘルス、経済機会を測定"
  },
  fiiFormula: {
    stats: {
      mentalDisorders: "7人に1人がメンタル障害の影響を受ける",
      mentalHealthLimiting: "68%がメンタルヘルスを制限要因として挙げる",
      emergingAccess: "新興市場（10-30%アクセス）",
      digitalSkillsGap: "仕事の92%がデジタルスキルを必要（訓練されているのは30%のみ）",
      youthVsAdult: "13%グローバル若者（vs 4.9%成人）",
      neetCrisis: "2億5600万人の若者（20.4%）が教育/仕事にいない",
      ssaAspiration: "サブサハラアフリカの若者の52%がビジネスを始めたい",
      fundingGap: "資金を得るのは3%のみ（グローバルで1.7兆ドルのギャップ）",
      womenGap: "女性起業家は35%代表不足"
    },
    reasoning: {
      mentalHealth: "高い加重は基礎的重要性を反映 - メンタルヘルスは他のすべての能力を可能にする",
      workforce: "重要な加重は雇用が経済的独立へのゲートウェイであることを反映",
      entrepreneurship: "重要な加重はイノベーションポテンシャルと自営業の必要性を反映"
    },
    mentalHealthStat1: "7人に1人がメンタル障害の影響を受ける",
    mentalHealthStat2: "68%がメンタルヘルスを制限要因として挙げる",
    mentalHealthStat3: "新興市場（10-30%アクセス）",
    workforceStat1: "仕事の92%がデジタルスキルを必要（訓練されているのは30%のみ）",
    workforceStat2: "13%グローバル若者失業（vs 4.9%成人）",
    workforceStat3: "2億5600万人の若者（20.4%）が教育/仕事にいない",
    entrepreneurshipStat1: "サブサハラアフリカの若者の52%がビジネスを始めたい",
    entrepreneurshipStat2: "資金を得るのは3%のみ（グローバルで1.7兆ドルのギャップ）",
    entrepreneurshipStat3: "女性起業家は35%代表不足",
    mentalHealthReasoning: "高い加重は基礎的重要性を反映 - メンタルヘルスは他のすべての能力を可能にする",
    workforceReasoning: "重要な加重は雇用が経済的独立へのゲートウェイであることを反映",
    entrepreneurshipReasoning: "重要な加重はイノベーションポテンシャルと自営業の必要性を反映"
  },
  engagement: {
    title: "エンゲージメントメトリクス",
    subtitle: "会員参加と活動分析",
    eventParticipation: "イベント参加",
    volunteerHours: "ボランティア時間",
    projectContributions: "プロジェクト貢献",
    monthlyActiveUsers: "月間アクティブユーザー"
  },
  network: {
    title: "ネットワーク分析",
    subtitle: "グローバルなつながりとコラボレーションパターン",
    totalConnections: "総つながり",
    activeProjects: "アクティブプロジェクト",
    strategicPartnerships: "戦略的パートナーシップ",
    knowledgeTransfer: "知識移転",
    collectiveImpact: "集合的インパクト",
    progress: "進捗",
    target: "目標"
  },
  trends: {
    title: "トレンド分析と予測",
    subtitle: "JCIの歴史的進化とAIベースの2026-2030年予測",
    historical: "歴史的進化（2015-2025）",
    predictions: "2026-2030年予測",
    confidence: "信頼度",
    keyTrends: "特定された主要トレンド",
    sustainedGrowth: "持続的成長",
    digitalRevolution: "デジタル革命",
    wellbeingFocus: "ウェルビーイングフォーカス",
    sustainability: "サステナビリティ",
    seasonalPatterns: "季節パターン",
    enrollments: "登録",
    projects: "プロジェクト",
    events: "イベント",
    members: "会員",
    countries: "国",
    imh: "MHI"
  },
  status: {
    strong: "強い",
    growing: "成長中",
    expanding: "拡大中",
    stable: "安定",
    emerging: "新興",
    active: "アクティブ",
    expansion: "拡大",
    pilot: "パイロット",
    beta: "ベータ"
  },
  advancedMetrics: {
    title: "高度なメトリクス",
    subtitle: "ビジョン2040のパフォーマンス、コンバージョン、主要指標の詳細分析",
    conversionFunnel: "コンバージョンファネル",
    websiteVisitors: "ウェブサイト訪問者",
    interested: "興味あり",
    candidates: "候補者",
    interviewed: "面接済み",
    activeMembers: "アクティブ会員",
    totalConversionRate: "総コンバージョン率",
    costPerAcquisition: "獲得コスト",
    programROI: "プログラムROI",
    performanceTrends: "パフォーマンストレンド",
    members: "会員",
    countries: "国",
    programs: "プログラム",
    keyPerformanceIndicators: "主要パフォーマンス指標",
    retentionRate: "継続率",
    membersActive12Months: "12ヶ月以上アクティブな会員",
    digitalEngagement: "デジタルエンゲージメント",
    onlineEventParticipation: "オンラインイベント参加",
    memberSatisfaction: "会員満足度",
    avgProgramEvaluation: "平均プログラム評価",
    averageLeadershipTime: "平均リーダーシップ時間",
    joiningToFirstLeadership: "入会から最初のリーダーシップポジションまで",
    target: "目標",
    progress: "進捗"
  },
  performanceKPIs: {
    title: "パフォーマンスKPIs",
    subtitle: "2025年の主要パフォーマンス指標と目標",
    updatedAgo: "更新",
    memberRetentionRate: "会員継続率",
    annualRetentionVsTarget: "年間会員継続 vs 目標",
    programROI: "プログラムROI",
    trainingProgramsROI: "トレーニングプログラムの投資収益率",
    newMarkets: "新市場",
    newCountriesEntered: "今年参入した新国",
    communityImpactScore: "コミュニティインパクトスコア",
    aggregateCommunityImpact: "集合的コミュニティインパクト測定",
    memberEngagement: "会員エンゲージメント",
    activeParticipationJCI: "JCI活動へのアクティブ参加",
    leadershipPipeline: "リーダーシップパイプライン",
    membersInLeadershipTrack: "リーダーシップ開発トラックの会員",
    performance: "パフォーマンス",
    growth: "成長",
    impact: "インパクト",
    engagement: "エンゲージメント",
    target: "目標"
  },
  aiInsights: {
    title: "AIインサイトセンター",
    subtitle: "インテリジェントな意思決定のための予測分析、戦略的推奨事項、「what-if」シナリオ",
    aiChat: "AIチャット",
    recommendations: "推奨事項",
    insights: "インサイト",
    whatIf: "What-If",
    jciAssistant: "JCIインテリジェントアシスタント",
    askAboutData: "データ、トレンド、戦略について質問",
    askPlaceholder: "トレンド、分析、戦略について質問...",
    greeting: "こんにちは！私はJCIインサイトアシスタントです。データを分析し、戦略的機会を発見するのをどのようにお手伝いできますか？",
    analyzing: "あなたの質問を分析中",
    growthPotential: "今後18ヶ月の成長ポテンシャル",
    priority: "優先度",
    confidence: "信頼度",
    viewDetails: "詳細を見る",
    expectedImpact: "予想されるインパクト",
    estimatedTime: "推定時間",
    simulateScenario: "シナリオをシミュレート",
    strategicExpansion: "ラテンアメリカでの戦略的拡大",
    strategicExpansionDesc: "データはコロンビアやペルーなどの国に40%の未探索成長ポテンシャルを示しています。",
    digitalMentalHealth: "デジタルメンタルヘルスプログラム",
    digitalMentalHealthDesc: "デジタルプラットフォームの実装により、若いコミュニティでのエンゲージメントが60%増加します。",
    techPartnerships: "テクノロジーパートナーシップ",
    techPartnershipsDesc: "ローカルスタートアップとの統合により、イノベーションプログラムが45%加速できます。",
    growth: "成長",
    wellbeing: "ウェルビーイング",
    innovation: "イノベーション",
    millennialEngagement: "ミレニアルエンゲージメント",
    millennialEngagementDesc: "25-30歳の参加の加速された成長",
    sustainableProjects: "持続可能なプロジェクト",
    sustainableProjectsDesc: "ESGイニシアチブは優れたROIを示した",
    regionalRetention: "地域継続",
    regionalRetentionDesc: "一部の地域は特別な注意が必要",
    whatIfLeadership: "リーダーシッププログラムへの投資を25%増やしたら？",
    whatIfLeadershipImpact: "リーダーシップの質が35%向上、イベント参加が2.3倍",
    whatIfAI: "すべての管理プロセスにAIを実装したら？",
    whatIfAIImpact: "管理時間が40%削減、年間210万ドルの節約",
    budget: "予算",
    months: "ヶ月",
    focusYoungLeaders: "若いリーダーにフォーカス",
    totalAutomation: "完全自動化",
    training: "トレーニング",
    gradualMigration: "段階的移行"
  },
  homeGlobalPresence: {
    title: "JCIグローバルプレゼンス",
    subtitle: "4地域114カ国でアクティブ",
    regions: "地域",
    countries: "国",
    members: "会員",
    localOrgs: "ローカル組織"
  },
  fii: {
    title: "ユースフューチャーズ指数（YFI）",
    measuringYouthOpportunity: "114カ国における若者の機会を測定",
    scale: "スケール: 0-100（高いほど若者の機会が良い）",
    mentalHealth: "メンタルヘルス",
    workforceEducation: "労働力と教育",
    entrepreneurshipSupport: "起業支援",
    mentalHealthQuote: "メンタルヘルスは他のすべての能力が構築される基盤です。",
    workforceQuote: "雇用は経済的独立への入口です。",
    entrepreneurshipQuote: "イノベーションと自営業は若者の機会にとって不可欠な道です。",
    globalCrisis: "グローバル危機",
    employmentBarrier: "雇用の障壁",
    mostVulnerable: "最も脆弱",
    skillGap: "スキルギャップ",
    unemployment: "若者失業",
    neetCrisis: "ニート危機",
    aspiration: "起業志向",
    fundingGap: "資金ギャップ",
    genderGap: "ジェンダーギャップ",
    whyThisWeighting: "なぜこの加重？",
    ofTotalScore: "総スコアの",
    weight: "重み",
    source: "出典",
    indicators: "指標",
    countriesMeasured: "測定国数",
    jciNationalOrgs: "JCI国内組織",
    completeData: "完全なデータ",
    countries: "カ国",
    averageFII: "平均YFI",
    highest: "最高",
    lowest: "最低",
    pointRange: "ポイント範囲",
    countriesRanked: "ランキング国数",
    excellent: "優秀",
    good: "良好",
    moderate: "中程度",
    deficient: "不足",
    challenges: "課題あり",
    critical: "危機的",
    globalRankings: "グローバルYFIインデックス",
    searchCountry: "国を検索...",
    allRegions: "すべての地域",
    rank: "順位",
    country: "国",
    region: "地域",
    score: "スコア",
    classification: "分類",
    
    // Component Breakdown & Benchmarks
    componentBreakdown: "構成要素の内訳",
    vsBenchmarks: "対ベンチマーク",
    vsGlobalAvg: "対世界平均",
    globalAverage: "世界平均",
    data: "データ",
    complete: "完全",
    limited: "限定的",
    
    // Legend labels
    legendGood: "良好",
    legendModerate: "中程度",
    legendChallenges: "課題あり",
    legendCritical: "危機的",
    
    useFIIData: "YFIデータを使用",
    useFIIDataDesc: "研究とアドボカシーのためにインデックスデータと方法論文書をダウンロード",
    exportRankings: "インデックスをエクスポート（CSV）",
    downloadMethodology: "方法論をダウンロード（PDF）",
    comingSoon: "近日公開",
    methodologyComingSoon: "方法論PDFは近日公開予定",
    researchCitations: "研究引用",
    sourceWhoDescription: "メンタルヘルスサービスへのアクセス、治療のギャップ、政策カバレッジ",
    sourceIloDescription: "若者の失業、NEET率、労働力の質",
    sourceGemDescription: "初期段階の起業家精神、ビジネス環境",
    sourceWorldBankDescription: "起業家精神次元の支援データ",
    aboutMethodology: "方法論について",
    aboutMethodologyDesc: "YFIはWHO、ILO、世界銀行およびその他の信頼できる情報源からの検証済みデータを使用しています。",
    howToCite: "引用方法",
    citationText: "JCI Development Councils Youth Futures Observatory (2025). ユースフューチャーズ指数。",
    insightsTitle: "戦略的インサイト",
    insightsSubtitle: "YFI分析からの主要な発見",
    finding: "発見",
    dataEvidence: "データ証拠",
    implication: "含意",
    actionForJCI: "JCIへのアクション",
    insight1Title: "基盤としてのメンタルヘルス",
    insight2Title: "スキル・雇用のミスマッチ",
    insight3Title: "地域間格差",
    insight4Title: "起業家精神のパラドックス",
    insight5Title: "ジェンダーギャップの持続",
    dataVintage: "データ期間",
    dataVintageDesc: "検証済み国際情報源からの2023-2024データ",
    methodologyTitle: "YFI方法論",
    methodologySubtitle: "将来インパクト指数の計算方法",
    formulaExplanation: "式の説明",
    pillarWeights: "柱の重み",
    dataSourcesTitle: "データソース",
    calculationFormula: "計算式",
    threeDimensions: "3つの次元",
    officialDataSources: "公式データソース",
    dataCoverage: "データカバレッジ",
    dataCoverageDesc: "YFIは114のJCI加盟国をカバーしています。データの利用可能性は国と指標によって異なります。",
    openData: "オープンデータ",
    openDataDesc: "すべてのソースデータは認定機関から公開されています。",
    zeroSynthetic: "ゼロ合成データ",
    zeroSyntheticDesc: "実際の検証済みデータのみを使用 - AI生成や推定値は一切使用しません。",
    fullTransparency: "完全な透明性",
    fullTransparencyDesc: "完全な方法論と計算が公開文書化されています。",
    scientificRigor: "科学的厳密さ",
    scientificRigorDesc: "方法論は研究パートナーによってレビューおよび検証されています。",
    regionalPerformance: "地域別パフォーマンス",
    topPerformers: "トップパフォーマー",
    bottomPerformers: "ボトムパフォーマー",
    keyTakeaways: "主要なポイント"
  },
  globalFIIMap: {
    title: "グローバルYFIマップ",
    subtitle: "すべてのJCI国における若者の機会メトリクスを探索",
    jciCountries: "JCI国",
    totalMembers: "総会員数",
    completeData: "完全なデータ",
    globalRegions: "グローバル地域",
    regionalOverview: "地域概要",
    countries: "国",
    avgFII: "平均YFI",
    leader: "リーダー",
    searchCountry: "国を検索...",
    allRegions: "すべての地域",
    allClassifications: "すべての分類",
    regionAsiaPacific: "アジアと太平洋",
    regionEurope: "ヨーロッパ",
    regionAmericas: "アメリカ",
    regionAfricaMe: "アフリカ・中東",
    excellent: "優秀",
    good: "良好",
    moderate: "中程度",
    deficient: "不足",
    critical: "危機的",
    countriesTotal: "国の合計",
    matching: "一致",
    fiiDataset: "YFIデータセット",
    withCompleteData: "完全なデータあり",
    limitedData: "限定データ",
    members: "会員"
  },
  fiiInsights: {
    insight: "インサイト",
    sourceAttribution: "JCIインパクトレポート2025 | YFI地域分析2024",
    priority: {
      critical: "重大",
      high: "高",
      medium: "中"
    },
    mentalHealth: {
      finding: "メンタルヘルスはYFI総合スコアの最も強力な予測因子です。メンタルヘルススコアが高い国は一貫して上位にランクされています。",
      mhScoreVariation: "MHスコアの変動",
      wfEtScoreVariation: "WF&Entスコアの変動",
      potentialImprovement: "潜在的YFI改善",
      implication: "メンタルヘルスへの投資は、全体的な若者の機会に対して最高のリターンをもたらします。",
      action: "JCIイニシアチブ、特に低スコア地域でメンタルヘルスプログラムを優先する。"
    },
    skillsMismatch: {
      finding: "教育への高い登録にもかかわらず、スキルのミスマッチにより若者の失業率は高いままです。",
      youthInEducation: "教育を受けている若者",
      youthUnemployment: "若者失業率",
      neetPopulation: "ニート人口",
      digitalSkillsJobs: "デジタルスキルが必要な仕事",
      implication: "従来の教育は現代の労働力に若者を準備させていません。",
      action: "デジタルおよび起業家スキルに焦点を当てたスキルベースのトレーニングプログラムを開発する。"
    },
    regionalDisparities: {
      finding: "地域間に大きなギャップがあり、アフリカ・中東が最大の課題に直面しています。",
      mentalHealthGap: "メンタルヘルスギャップ（ヨーロッパ vs アフリカ・中東）",
      workforceGap: "労働力ギャップ",
      entrepreneurshipGap: "起業ギャップ",
      implication: "画一的なアプローチは機能しません。地域別の戦略が必要です。",
      action: "地域固有のプログラムを開発し、サービスが行き届いていない地域へのリソース配分を増やす。"
    },
    entrepreneurship: {
      finding: "発展途上地域では高い起業志向がありますが、資本へのアクセスは厳しく制限されています。",
      ssaRate: "SSA起業率",
      financingGap: "グローバル資金ギャップ",
      africaMeShare: "グローバルスタートアップにおけるアフリカ・中東のシェア",
      youthWanting: "ビジネスを始めたい若者",
      implication: "資金調達へのアクセスによって制約された未開拓の起業家ポテンシャルが存在します。",
      action: "マイクロファイナンスプログラムを作成し、若い起業家を投資家と結び付ける。"
    },
    gender: {
      finding: "女性はYFIの3つの次元すべてで複合的な不利益に直面しています。",
      depressionRates: "女性のうつ病率",
      womenUnemployment: "女性の失業率",
      neetWomen: "ニートにおける女性の割合",
      womenLedStartups: "女性主導のスタートアップ",
      vcToWomen: "女性へのVC資金",
      implication: "ジェンダー固有の障壁にはターゲットを絞った介入が必要です。",
      action: "女性に焦点を当てたリーダーシップと起業プログラムを立ち上げる。"
    }
  },
  fiiMethodology: {
    formulaExplanation: "YFIは3つの次元の加重平均として計算されます：メンタルヘルス（40%）、労働力と教育（30%）、起業支援（30%）。",
    mentalHealth: {
      description: "若者のメンタルウェルネス、メンタルヘルスサービスへのアクセス、全体的な心理的幸福を測定します。"
    },
    workforce: {
      description: "若者の雇用率、教育の質、スキル開発、労働市場へのアクセスを評価します。"
    },
    entrepreneurship: {
      description: "ビジネス環境、資金調達へのアクセス、デジタルインフラ、スタートアップエコシステムを評価します。"
    },
    indicators: {
      mentalDisorderPrevalence: "精神障害有病率",
      youthSuicideRate: "若者自殺率",
      mentalHealthServiceAccess: "メンタルヘルスサービスへのアクセス",
      mentalWellbeingIndex: "メンタルウェルビーイング指数",
      youthUnemploymentRate: "若者失業率",
      neetRate: "ニート率",
      tertiaryEducation: "高等教育登録",
      humanCapitalIndex: "人的資本指数",
      easeOfDoingBusiness: "ビジネスのしやすさ",
      totalEntrepreneurialActivity: "総起業活動",
      accessToFinancing: "資金調達へのアクセス",
      digitalInfrastructure: "デジタルインフラ"
    },
    dataTypes: {
      education: "教育",
      multiDimensional: "多次元",
      wellbeing: "ウェルビーイング",
      digitalInfrastructure: "デジタルインフラ"
    },
    access: {
      publicApiDownloads: "公開APIとダウンロード",
      ilostatPublicApi: "ILOSTAT公開API",
      publicDataPortal: "公開データポータル",
      freeApiAccess: "無料APIアクセス",
      publicReports: "公開レポート",
      publicData: "公開データ",
      annualPublicRelease: "年次公開リリース",
      publicStatistics: "公開統計"
    }
  }
} as const;

